/**
 * The SampleQCSplit data model (`SpreadSheetBuilder_TemplateInfo.Model = 4`, OG `EnumModel.SampleQCSplit`,
 * Windows builder + OG web 2026-09-30) — the batch's SAMPLE rows are entered on a worksheet named
 * `SampleResults` and its QC rows on one named `QCResults`. The Template Builder authors both sheets (the
 * detail sheet renamed + a copy); OG GenerateMailMergeSampleQC merges each sheet with its group only and
 * BindSampleQCToGrid reads each group back off its own sheet. Twin of the server's `SdmsSampleQcSplit`.
 */

/** The model's stored value. */
export const SAMPLE_QC_SPLIT_MODEL = 4;

/** The worksheet holding the sample rows. */
export const SAMPLE_RESULTS_SHEET = 'SampleResults';

/** The worksheet holding the QC rows. */
export const QC_RESULTS_SHEET = 'QCResults';

/** The two result sheets, in OG's order. */
export const SAMPLE_QC_SPLIT_SHEETS: readonly string[] = [SAMPLE_RESULTS_SHEET, QC_RESULTS_SHEET];

/** True for one of the two result sheets (exact name, as OG's `Worksheets[i].Name == …`). */
export function isSampleQcSplitSheet(name: string): boolean {
  return name === SAMPLE_RESULTS_SHEET || name === QC_RESULTS_SHEET;
}

/** True for a SAMPLE row: no QC type, or the QC type "Sample". OG's filter is
 *  `QCType IS NULL OR QCType='' OR QCType = 'SAMPLE'` on a DataTable, which compares case-insensitively.
 *  The merge records name the column `QCType` (any case). */
export function isSampleRow(record: Readonly<Record<string, unknown>>): boolean {
  const key = Object.keys(record).find(k => k.toUpperCase() === 'QCTYPE');
  const v = key === undefined ? null : record[key];
  if (v == null) return true;
  const s = String(v);
  return s === '' || s.toUpperCase() === 'SAMPLE';
}
